export enum TimesheetStatusGroup {
  PENDING = 'pending',
  DISPUTED = 'disputed',
  APPROVED = 'approved',
}
